import { Injectable } from '@angular/core';

// Holds the "Auto assign Probates" checkbox state. ReportingComponent is recreated on every
// navigation (NoReuseStrategy), so this needs to live outside the component to survive the
// reload when auto-assign carries the user straight into their next probate.
@Injectable({ providedIn: 'root' })
export class AutoAssignService {
  enabled = false;
}
